module.exports = __webpack_public_path__ + "0531f3d4aafde14148b98a1811740408.png";